<!-- SELECT ALL IMAGE & DELETE -->
<div
  *ngIf="selectable"
  class="d-flex h-34px justify-content-between mb-24px w-100">
  <div class="align-items-center d-flex gap-12px w-auto">
    <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll($event)">{{'COMMON.SELECT_ALL_'+(this.mediaGroup === 'VIDEO' ? 'VIDEO' : 'IMAGE') | translate }}
  </div>
  <div class="h-34px w-100px">
    <app-icon-button
      *ngIf="anySelected()"
      (click)="deleteSelected()"
      [label]="'COMMON.DELETE'"
      [labelClass]="'text-danger'"
      [iconType]="'fa-solid'"
      [extraClasses]="'h-34px'"
      [iconClass]="'fa-trash-can text-danger'"
    ></app-icon-button>
  </div>
</div>

<div class="row min-h-225px">

  <!-- RENDER IMAGES BOXES -->
  <div class="d-flex gap-32px flex-wrap align-items-start {{ compactMode? 'w-80pct' : '' }}">
    <app-upload-image-box
      *ngFor="let data of previewImages; let i = index"
      #uploadBox
      [status]="data.media_tickets?.ticket_category! | uppercase"
      [isSelectable]="selectable"
      [isVideo]="data.media_group === 'VIDEO'"
      [useHeader]="data.title"
      [media]="data"
      [error]="data.error"
      [haveAction]="showActions"
      [useCustomAction]="true"
      [showVideoPlayButton]="mode !== 'input'"
      (selectedChange)="refreshSelectAllCheckbox()"
      (previewHandler)="openImageViewer(i)"
      (deleteHandler)="deleteMedia(i)"
      (customActionHandler)="mode === 'input'? openUploadModal(i) : openImageViewer(i)">
    </app-upload-image-box>
  </div>

  <!-- VIEW MORE BUTTON -->
  <div *ngIf="compactMode && viewMoreCount > 0"
    class="w-20pct d-flex align-items-center">
    <app-icon-button title="View More"
      extraClasses="justify-content-start"
      [outlined]="true"
      (click)="openMoreGallery()"
      iconType="fa-regular"
      iconClass="fa-eye text-primary">
      {{ 'COMMON.VIEW_MORE' | translate:{count: viewMoreCount} }}
    </app-icon-button>
  </div>
</div>

<!-- MODAL IF USER CLICKS VIEW MORE BUTTON -->
<app-media-gallery-modal
  #galleryModal
  *ngIf="compactMode"
  [modalTitle]="mediaTitle"
  [mediaList]="mediaList">
</app-media-gallery-modal>

<app-modal-upload-media
(successUpload)="handleSuccessUpload($event)">
</app-modal-upload-media>
